import React from 'react';

const PrivacyPolicy: React.FC = () => (
  <div style={{ padding: 24, maxWidth: 800, margin: '0 auto', background: '#fff', borderRadius: 8 }}>
    <h1>平台隐私政策</h1>
    <p>本隐私政策旨在说明达康AI医生平台如何收集、使用和保护您的个人信息。</p>
    <h2>1. 信息收集</h2>
    <p>我们会在您注册、使用服务时收集必要的个人信息，如手机号、健康信息等。</p>
    <h2>2. 信息使用</h2>
    <p>收集的信息仅用于为您提供服务、改进体验及保障安全。</p>
    <h2>3. 信息保护</h2>
    <p>我们采取多种安全措施保护您的信息，防止数据丢失、被滥用或被篡改。</p>
    <h2>4. 信息披露</h2>
    <p>未经您的同意，我们不会向第三方披露您的个人信息，法律法规另有规定除外。</p>
    <h2>5. 政策变更</h2>
    <p>本政策如有更新，将在平台公示，请您及时关注。</p>
  </div>
);

export default PrivacyPolicy; 